import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider, Empty, Table } from "antd";
import { useNavigate } from "react-router";
import { ReactComponent as CheckedIcon } from "../../../../assests/images/checked.svg";
import unCheckedIcon from "../../../../assests/icons/uncheck.png";
import { amountFormat } from "../../../../services/common.service";
import moment from "moment";

export default function DepositGridView({
  dataSource = [],
  handleChange,
  noRecords,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  return (
    <div style={{ padding: "0px" }}>
      <Table
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        style={{ cursor: "pointer" }}
        tableLayout="fixed"
        rowKey={"accountNo"}
        pagination={false}
        bordered
        expandable={{
          defaultExpandAllRows: false,
          expandRowByClick: true,
          expandedRowKeys: expandedRowKeys,

          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <CheckedIcon
                onClick={(e) => onExpand(record, e)}
                height={18}
                className="checked"
              />
            ) : (
              <img
                src={unCheckedIcon}
                onClick={(e) => onExpand(record, e)}
                height={18}
                className="unchecked"
              />
            ),
          onExpand: (expanded, record) => {
            if (expanded) {
              setExpandedRowKeys([record.accountNo]);
            } else {
              setExpandedRowKeys([]);
            }
          },
          expandedRowRender: (account) => (
            <div className="d-flex align-items-center">
              <Button
                type="default"
                className="secondary-btn"
                onClick={() =>
                  navigate("/accounts/deposit/summary", {
                    state: { ...account },
                  })
                }
              >
                {t("pages.my_accounts.common_my_accounts.ac_details", {
                  defaultValue: "A/c Details",
                })}
              </Button>
              <Divider type="vertical" />
              <Button
                type="default"
                className="secondary-btn"
                onClick={() =>
                  navigate("/accounts/deposit/statement", {
                    state: { ...account },
                  })
                }
              >
                {t("navigation.statement", {
                  defaultValue: "Statement",
                })}
              </Button>
            </div>
          ),
        }}
        sticky={true}
        columns={[
          {
            title: "Account Number",
            key: "accountNo",
            dataIndex: "accountNo",
            width: 180,
          },
          {
            title: "Depositor Name",
            key: "acctShortName",
            ellipsis: true,
            render: (account) => (
              <>
                <span>{account.acctShortName || account.accountName}</span>
              </>
            ),
          },
          {
            title: "Maturity Date",
            key: "maturityDate",
            width: 200,
            render: (account) => (
              <>
                <span>
                  {moment(account?.maturityDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "ROI",
            key: "interestRate",
            width: 200,
            render: (account) => (
              <>
                <span>
                  {account.interestRate || "-"}
                  {account.interestRate ? "%" : ""}
                </span>
              </>
            ),
          },
          {
            title: <span>Balance </span>,
            key: "currentBalance",
            width: 200,
            align: "right",
            render: (account) => (
              <>
                <span>
                  {amountFormat(
                    account.currentBalance,
                    account.accountCurrency
                  )}
                </span>
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
